<!-- @format -->

<template>
	<el-dialog
		v-if="dialogVisible"
		v-model="dialogVisible"
		:title="title"
		custom-fullscreen-class="ibps-dialog-70"
		:top="marginTop"
		width="700"
		@fullscreen="handleFullscreen"
		@close="closeDialog"
	>
		<el-tabs v-model="activeName" class="uploader-tab" @tab-click="onTabClick">
			<el-tab-pane v-if="!options || !options.uploadHidden" :label="'上传附件'" name="upload">
				<el-row :gutter="20">
					<el-col v-if="isHistory" :span="18">
						<el-table
							ref="elTable"
							v-loading="listLoading"
							:data="listData"
							:row-key="getRowKey"
							:height="tableHeight"
							border
							@row-click="handleRowClick"
							@selection-change="handleSelectionChange"
						>
							<!--选择列 多选-->
							<el-table-column
								v-if="(selectionRow || selectionRow === '') && selectionType === 'checkbox'"
								v-bind="typeof selectionRow === 'Object' ? selectionRow : null"
								:label="handleAttribute(selectionRow.label, '')"
								:reserve-selection="true"
								type="selection"
							/>
							<!--选择列 单选-->
							<el-table-column
								v-if="(selectionRow || selectionRow === '') && selectionType === 'radio'"
								:label="selectionRow.label || ''"
								:width="selectionRow.width || 55"
							>
								<template #default="scope">
									<div @click.stop>
										<el-radio v-model="selectionRadio" :label="scope.row[pkKey]" @change="changeRowRadio(scope.row)"
											><span>&nbsp;</span></el-radio
										>
									</div>
								</template>
							</el-table-column>
							<el-table-column :label="'文件名'" prop="resourceName" />
							<el-table-column :label="'扩展名'" prop="resourceExtend" />
						</el-table>
					</el-col>
					<el-col v-else :span="18">
						<el-table
							ref="elTable"
							v-loading="listLoading"
							:data="fileList"
							:row-key="getRowKey"
							:height="tableHeight"
							border
							@row-click="handleRowClick"
							@selection-change="handleSelectionChange"
						>
							<!--选择列 多选-->
							<el-table-column
								v-if="(selectionRow || selectionRow === '') && selectionType === 'checkbox'"
								v-bind="typeof selectionRow === 'Object' ? selectionRow : null"
								:label="handleAttribute(selectionRow.label, '')"
								:reserve-selection="true"
								type="selection"
							/>
							<!--选择列 单选-->
							<el-table-column
								v-if="(selectionRow || selectionRow === '') && selectionType === 'radio'"
								:label="selectionRow.label || ''"
								:width="selectionRow.width || 55"
							>
								<template #default="scope">
									<div @click.stop>
										<el-radio v-model="selectionRadio" :label="scope.row[pkKey]" @change="changeRowRadio(scope.row)"
											><span>&nbsp;</span></el-radio
										>
									</div>
								</template>
							</el-table-column>
							<el-table-column :label="'文件名'" prop="resourceName" />
							<el-table-column :label="'扩展名'" prop="resourceExtend" />
						</el-table>
					</el-col>
					<el-col :span="6">
						<upload-annex
							ref="upload"
							:multiple="multiple"
							:file-size="size"
							:accept="acceptRule"
							:fullscreen="fullscreen"
							:height="height"
							:init="dialogVisible"
							:limit="limit"
							:folder-alias="folderAlias"
							@callback="uploadCallback"
						/>
					</el-col>
				</el-row>
			</el-tab-pane>
		</el-tabs>
		<template #footer>
			<span class="dialog-footer">
				<pc-toolbar :actions="toolbars" @action-event="handleActionEvent" />
			</span>
		</template>
	</el-dialog>
</template>

<script>
	import { fileTypes, allFileTypes, accept as acceptTypes } from './constants/fileTypes';
	import uploadAnnex from './upload';
	import { PcToolbar } from '@/components/pc-toolbar/index';
	import { getAnnexFileList } from '@/api/global/index';
	import { $utils } from '@/utils/publicUtils';

	export default {
		components: {
			uploadAnnex,
			// online,
			PcToolbar,
		},
		props: {
			value: {
				type: [String, Number, Array, Object],
			},
			multiple: {
				type: Boolean,
				default: false,
			},
			visible: {
				type: Boolean,
				default: false,
			},
			title: {
				type: String,
				default() {
					return '文件上传';
				},
			},
			marginTop: {
				type: String,
				default: '15vh',
			},
			height: {
				type: String,
				default: '240px',
			},
			fileSize: [Number, String],
			limit: {
				type: Number,
			},
			accept: {
				type: String,
				default: '',
			},
			fileExt: {
				type: Array,
				default: () => [],
			},
			options: {
				type: Object,
				default: () => {},
			},
			folderAlias: {
				type: String,
				default: '',
			},
			isHistory: {
				type: Boolean,
				default: true,
			}, //是否显示历史
			isMy: {
				type: String,
				default: 'N',
			}, //是否显示自己的上传记录
		},
		data() {
			return {
				fullscreen: false,
				dialogVisible: this.visible,
				activeName: 'upload',
				buttonKey: 'confirm',
				onlineLoad: false,
				format: true,

				fileTypes,
				allFileTypes,
				acceptTypes,
				size: null,
				targetExt: false,
				acceptRule: '',
				uploadFileList: [],
				onlineFileList: [],
				fileList: [],

				toolbars: [
					{ key: 'save', type: 'primary', size: 'default' },
					{
						key: 'clear',
						label: '清空',
						size: 'default',
						hidden: () => {
							if (this.activeName === 'upload') return false;
							return true;
						},
					},
					{ key: 'cancel', size: 'default' },
				],
				listData: [],
				listLoading: false,
				tableHeight: 300,
				selectionRadio: '',
				pkKey: 'id',
				selectionRow: true,
				multipleSelection: [],
				selectionRadioObj: {},
			};
		},
		computed: {
			selectionType() {
				return this.multiple ? 'checkbox' : 'radio';
			},
		},
		watch: {
			visible: {
				handler(val) {
					this.dialogVisible = this.visible;
					this.activeName = 'upload';
					this.uploadFileList = [];
					if (this.isHistory && val) {
						this.loadData();
					}
					if (!this.multiple && val && $utils.isNotEmpty(this.value)) {
						this.selectionRadioObj = this.value;
						this.selectionRadio = this.value[this.pkKey];
					}
				},
				immediate: true,
			},
			dialogVisible: {
				handler(val) {
					this.$nextTick(() => {
						if (this.multiple && val && $utils.isNotEmpty(this.value)) {
							this.value.forEach((row) => {
								this.$refs.elTable.toggleRowSelection(row, true);
							});
						}
					});
				},
				immediate: true,
			},
			accept: {
				handler(val) {
					if (val === '*' && this.fileExt.length !== 0) {
						const str = `.${this.fileExt.join(',').replace(/,/g, ',.')}`;
						this.acceptRule = str;
					} else {
						this.acceptRule = val;
					}
				},
				immediate: true,
			},
			fileSize: {
				handler(val) {
					if ($utils.isNotEmpty(val)) {
						this.size = typeof val === 'number' ? val * 1024 * 1024 : parseFloat(val) * 1024 * 1024;
					}
				},
				immediate: true,
			},
		},
		beforeUnmount() {
			this.fileTypes = null;
			this.allFileTypes = null;
			this.acceptTypes = null;
			this.uploadFileList = null;
			this.onlineFileList = null;
			this.fileList = null;
			this.toolbars = null;
		},
		methods: {
			handleFullscreen(val) {
				this.fullscreen = val;
			},
			handleActionEvent({ key }) {
				switch (key) {
					case 'save':
						this.handleConfirm();
						break;
					case 'cancel':
						this.closeDialog();
						break;
					case 'clear':
						this.handleClearFiles();
						break;
					default:
						break;
				}
			},
			handleClearFiles() {
				this.uploadFileList = [];
				this.fileList = [];
				this.multipleSelection = [];
				this.selectionRadioObj = {};
				if (this.multiple) {
					this.$refs.upload.clearFiles();
				}
			},
			uploadCallback(data) {
				this.uploadFileList = data;
				if (this.multiple) {
					this.fileList = $utils.isNotEmpty(this.value) ? [...this.value, ...this.uploadFileList] : this.uploadFileList;
				} else {
					this.onlineFileList = [];
					this.fileList.push(this.uploadFileList);
				}
				if (this.isHistory) {
					this.loadData();
				}
			},
			onlineCallback(data) {
				this.onlineFileList = data;
				if (this.multiple) {
					this.fileList = $utils.isNotEmpty(this.value) ? [...this.uploadFileList, ...data, ...this.value] : data;
				} else {
					this.uploadFileList = [];
					this.fileList = data;
				}
			},
			// 关闭当前窗口
			closeDialog() {
				this.uploadFileList = [];
				this.onlineFileList = [];
				this.$emit('close', false);
			},
			onTabClick(tab) {
				if (tab.name === 'online') {
					this.onlineLoad = !this.onlineLoad;
				}
			},
			onFormat(format) {
				this.format = format;
			},
			/**
			 * 文件类型的限制
			 */
			fileExtType() {
				const accept = this.accept;
				const acceptTypes = this.acceptTypes;
				const fileTypes = this.fileTypes;
				let type = '';
				let targetFileTypes = [];
				this.targetExt = false;
				for (const i in acceptTypes) {
					if (acceptTypes[i] === accept) {
						type = i;
						targetFileTypes = fileTypes[i];
					} else {
						if (accept === '*') {
							// 不限制
							targetFileTypes = '*';
						} else {
							// 自定义
							targetFileTypes = accept.split(',');
						}
					}
				}
				const fileList = this.multiple ? this.fileList : [this.fileList];
				if (targetFileTypes !== '*') {
					this.targetExt = fileList.every((i) => {
						// console.log(targetFileTypes, `.${i.ext}`) // 控件类型集，过滤文件得后缀
						if (type === 'compress') {
							return targetFileTypes.includes(`${i.resourceExtend}`);
						} else {
							return targetFileTypes.includes(`.${i.resourceExtend}`);
						}
					});
				} else {
					this.targetExt = true;
				}
				// console.log(fileList, this.targetExt, 'lll') // 已上传文件，过滤结果
				return this.targetExt;
			},
			handleConfirm() {
				if (!this.multiple) {
					if ($utils.isNotEmpty(this.selectionRadio) && [this.selectionRadio].length > 1) {
						this.$message.closeAll();
						this.$message({
							message: '附件上传设置为单选，选择文件数量只能为1个',
							type: 'warning',
						});
						return;
					}
				}
				if ($utils.isNotEmpty(this.limit) && this.limit < this.multipleSelection.length) {
					this.$message.closeAll();
					this.$message({
						message: `超过设置最大上传数量限制${this.limit}张`,
						type: 'warning',
					});
					return;
				}
				if (this.multiple) {
					this.$emit('action-event', this.buttonKey, this.multipleSelection);
				} else {
					this.$emit('action-event', this.buttonKey, this.selectionRadioObj);
				}
			},
			// 查询列表数据
			loadData() {
				this.listLoading = true;
				const obj = {
					folderAlias: this.folderAlias,
					groupKey: '',
					isMy: this.isMy,
					fileType: '',
					fileSize: '',
					pageNo: 1,
					limit: 20,
				};
				getAnnexFileList(obj)
					.then((response) => {
						this.listData = response.rows;
						this.listLoading = false;
					})
					.catch(() => {
						this.listLoading = false;
					});
			},
			getRowKey(row) {
				return row.id;
			},
			handleSelectionChange(val) {
				if (this.limit && this.limit === 0) {
					this.$message.closeAll();
					this.$message({
						message: '上传个数不能为0',
						type: 'warning',
					});
					return;
				}
				let pass = true;
				val.forEach((i) => {
					if ($utils.isNotEmpty(this.fileSize) && this.fileSize < i.totalBytes) {
						this.$message.closeAll();
						this.$message({
							message: `上传文件的大小大于${$utils.formatSize(this.fileSize)}`,
							type: 'warning',
						});
						pass = false;
						this.$refs.elTable.toggleRowSelection(i, pass);
					}
				});
				if (!pass) {
					return;
				}
				this.multipleSelection = val;
				// this.multipleSelection = $utils.isNotEmpty(this.value) ? [...this.value, ...val] : val;
				// this.$emit('callback', val);
			},
			/**
			 * @description 行点击时触发的事件
			 */
			handleRowClick(row, event, column) {
				// 点击行，触发选中
				if ($utils.isNotEmpty(this.fileSize) && this.fileSize < row.totalBytes) {
					this.$message.closeAll();
					this.$message({
						message: `上传文件的大小大于${$utils.formatSize(this.fileSize)}`,
						type: 'warning',
					});
					return;
				}
				if (this.selectionType === 'radio') {
					this.selectionRadioObj = row;
					this.selectionRadio = row[this.pkKey];
				} else {
					this.$refs.elTable.toggleRowSelection(row);
				}
				this.format = true;
				this.$emit('row-click', row, event, column);
				this.$emit('format', this.format);
			},
			/**
			 * @description 单选点击时触发的事件[阻止冒泡后单选值补充]
			 */
			changeRowRadio(row) {
				if ($utils.isNotEmpty(this.fileSize) && this.fileSize < row.totalBytes) {
					this.$message.closeAll();
					this.$message({
						message: `上传文件的大小大于${$utils.formatSize(this.fileSize)}`,
						type: 'warning',
					});
					return;
				}
				// if (
				// 	this.$utils.isNotEmpty(this.accept) &&
				// 	this.accept &&
				// 	!this.fileExtType({ name: `${row.fileName}.${row.ext}` })
				// ) {
				// 	this.$message.closeAll();
				// 	this.$message({
				// 		message: '不允许的文件类型',
				// 		type: 'warning',
				// 	});
				// 	return;
				// }
				this.selectionRadioObj = row;
				this.selectionRadio = row[this.pkKey];
			},
			toggleRowSelection(row, selected) {
				if (this.selectionType === 'radio') {
					this.selectionRadioObj = row;
					this.selectionRadio = row ? row[this.pkKey] : '';
				} else {
					this.$refs.elTable.toggleRowSelection(row, selected);
				}
			},
			/**
			 * @description 组件属性默认值
			 */
			handleAttribute(attribute, defaultValue) {
				if (attribute === false || attribute === 0 || attribute === '') {
					return attribute;
				}
				return attribute || defaultValue;
			},
		},
	};
</script>
